import { IconCheck, IconLayoutGrid } from '@tabler/icons-react';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'shared/Button';
import { Radio } from 'shared/Input';
import { DEFAULT_GROUP_BY, GROUP_BY_OPTIONS } from '../constants';
import { useSiteSelectorContext } from '../SiteSelectorContext';
import { PopoverForm } from './PopoverForm';

export const GroupByPopover = () => {
    const { t } = useTranslation('navigation', {
        keyPrefix: 'site_selector.controls',
    });

    const { groupBy, setGroupBy } = useSiteSelectorContext();

    const [groupByLocal, setGroupByLocal] = useState(groupBy);

    const onCloseGroupBy = useCallback(() => {
        setGroupByLocal(groupBy);
    }, [groupBy]);

    return (
        <PopoverForm
            dirty={groupBy !== DEFAULT_GROUP_BY}
            icon={IconLayoutGrid}
            label={t('group_by.label')}
            onClose={onCloseGroupBy}
            onSubmit={(event) => {
                event.preventDefault();
                setGroupBy(groupByLocal);
            }}
        >
            {GROUP_BY_OPTIONS.map((groupByOption) => (
                <div key={groupByOption} className="mb-2">
                    <Radio
                        className="-mr-2"
                        id={groupByOption}
                        label={t(`group_by.option.${groupByOption}`)}
                        name="groupBy"
                        option={groupByOption}
                        value={groupByLocal}
                        onChange={(value) => setGroupByLocal(value)}
                    />
                </div>
            ))}

            <Button className="ml-auto mt-4" outline size="xs" type="submit">
                {t('cta.apply')}
                <IconCheck />
            </Button>
        </PopoverForm>
    );
};
